import { usePlayerRollCompetitionAwards } from '@/api/player-roll-competition-awards';
import { rollCompetitionPrizesColumns } from '@/constants/roll-competition-prizes';
import { TableWithPagination } from '@starsoft/common/components';

export default function RollCompetitionContentRendererLastRewards() {
  const {
    error,
    fetchNextPage,
    fetchPreviousPage,
    isPending,
    page,
    refetch,
    playerRollCompetitionAwards,
    setCurrentPage,
  } = usePlayerRollCompetitionAwards();

  return (
    <TableWithPagination
      data={playerRollCompetitionAwards}
      columns={rollCompetitionPrizesColumns}
      error={error}
      fetchNextPage={fetchNextPage}
      fetchPreviousPage={fetchPreviousPage}
      page={page}
      isLoading={isPending}
      refetch={refetch}
      setCurrentPage={setCurrentPage}
    />
  );
}
